import { render, staticRenderFns } from "./VideoBg.vue?vue&type=template&id=367c4727&scoped=true&"
import script from "./VideoBg.vue?vue&type=script&lang=js&"
export * from "./VideoBg.vue?vue&type=script&lang=js&"
import style0 from "./VideoBg.vue?vue&type=style&index=0&id=367c4727&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "367c4727",
  null
  
)

export default component.exports